import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

const PlaceHolder = ({txt}) => {
  return (
    <Container>
      <Row>
        <Col sm={12}>
          <Card style={{marginTop: '200px', marginBottom: '400px', background: '#000', color: '#63de00'}}>
            <Card.Body>
              <Card.Title>$/> {txt}</Card.Title>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>

  )
};
  
export default PlaceHolder;